module.exports = __webpack_public_path__ + "media/brands/bashan-225e4310.png";